const content = `${['BT', '/F1 24 Tf 100 700 Td (Hello World PDF) Tj', 'ET'].join('\n')}\n`;

// first part of the PDF, without the xref section and startxref
const beforeXref = `${[
  '%PDF-1.3',
  '1 0 obj',
  '<< /Type /Catalog /Pages 2 0 R >>',
  'endobj',
  '2 0 obj',
  '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
  'endobj',
  '3 0 obj',
  `<<
    /Type /Page
    /Parent 2 0 R
    /MediaBox [0 0 612 792]
    /Contents 4 0 R
    /Resources <<
      /Font <<
        /F1 5 0 R
      >>
    >>
  >>`,
  'endobj',
  // content stream
  `4 0 obj
<< /Length ${new TextEncoder().encode(content).length} >>
stream
${content}endstream
endobj`,
  '5 0 obj',
  `<<
    /Type /Font
    /Subtype /Type1
    /BaseFont /Helvetica
  >>`,
  'endobj',
].join('\n')}\n`;

// calculate the offset
const encoder = new TextEncoder();
const startxrefOffset = encoder.encode(beforeXref).length;

// now build the xref and trailer section
const xrefAndTrailer = `${[
  'xref',
  '0 6',
  '0000000000 65535 f ',
  '0000000010 00000 n ',
  '0000000053 00000 n ',
  '0000000103 00000 n ',
  '0000000203 00000 n ',
  // here, if you want, you can similarly recalculate the last xref entry
  'trailer',
  '<< /Size 6 /Root 1 0 R >>',
  'startxref',
  startxrefOffset.toString(),
  '%%EOF',
].join('\n')}\n`;

// the final PDF
const pdfText = beforeXref + xrefAndTrailer;
const pdfBytes = encoder.encode(pdfText);

export const SAMPLE_PDF: Blob = new Blob([pdfBytes], {
  type: 'application/pdf',
});
